module.exports = __webpack_public_path__ + "facebook-logo-grey.52f90976e1f26f74a294.svg";


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/assets/icons/facebook-logo-grey.svg
// module id = ../../../../../src/assets/icons/facebook-logo-grey.svg
// module chunks = main